module.exports = __webpack_public_path__ + "img/img11.9c15bfbe.jpg";